export const state = {
  username: null || sessionStorage.getItem('username'),
  password: null,
  acl: 0,
  otp: null,
  requestOtp: false,
  isLogged: !!sessionStorage.getItem('authToken'),
  loading: false,
  error: {
    status: false,
    message: null
  }
}

export const getters = {
  getPermissions: (state, getters, rootState, rootGetters) => {
    const acl = state.acl
    const perm = rootGetters['acl/getPermissions']({ acl })
    return perm
  }
}

export const mutations = {
  SET_USERNAME (state, payload = null) {
    state.username = payload
  },
  SET_PASSWORD (state, payload = null) {
    state.password = payload
  },
  CLEAR_PASSWORD (state) {
    state.password = null
  },
  SET_ACL (state, payload = 0) {
    state.acl = payload
  },
  SET_OTP (state, payload = null) {
    state.otp = payload
  },
  CLEAR_OTP (state) {
    state.otp = null
    state.requestOtp = false
  },
  SET_REQUEST_OTP (state, payload = false) {
    state.requestOtp = payload
  },
  SET_IS_LOGGED (state, payload = false) {
    state.isLogged = payload
  },
  SET_LOGGED_USER (state, { username = null, authToken = null }) {
    state.username = username

    if (username && authToken) {
      sessionStorage.setItem('username', username)
      sessionStorage.setItem('authToken', authToken)
    }
  },
  CLEAR_LOGGED_USER (state) {
    state.username = null
    state.acl = 0

    sessionStorage.removeItem('username')
    sessionStorage.removeItem('authToken')
  },
  SET_LOADING (state, payload = false) {
    state.loading = payload
  },
  SET_ERROR (state, { status = true, message = null }) {
    state.error.status = status
    state.error.message = message
  },
  CLEAR_ERROR (state) {
    state.error.status = false
    state.error.message = null
  },
  CLEAR_AFTER_LOGIN (state) {
    state.password = null
    state.otp = null
    state.requestOtp = false
    state.loading = false
    state.error.status = false
    state.error.message = null
  },
  CLEAR_AFTER_ERROR (state) {
    state.password = null
    state.otp = null
    state.loading = false
  },
  RESET (state) {
    state.password = null
    state.acl = 0
    state.otp = null
    state.requestOtp = false
    state.loading = false
    state.error.status = false
    state.error.message = null
    sessionStorage.removeItem('username')
    sessionStorage.removeItem('authToken')
  }
}

export const actions = {
  async doLogin ({ commit, dispatch, state, rootState }) {
    commit('SET_LOADING', true)

    const body = {
      usr: state.username,
      pwd: state.password
    }

    if (state.otp) body.otp = state.otp

    const hsm = rootState.hsm.instance

    try {
      const res = await hsm.login({ body })

      commit('SET_IS_LOGGED', true)
      commit('SET_LOGGED_USER', { username: body.usr, authToken: res.token })
      commit('CLEAR_AFTER_LOGIN')
      commit('hsm/RENEW_INSTANCE', null, { root: true })
      dispatch('doSetAcl')
      dispatch('error/clearError', null, { root: true })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      const errors = rootState.error.list
      const invalidPayloadRcCode = 2147488669
      if (err.rc === invalidPayloadRcCode && errors.length < 10) {
        return dispatch('doLogin')
      }
      commit('RESET')
      throw err
    } finally {
      commit('hsm/RENEW_INSTANCE', null, { root: true })
      commit('SET_LOADING', false)
    }
  },
  async doLogout ({ commit, dispatch, rootState }) {
    try {
      const hsm = rootState.hsm.instance
      await hsm.logout()
    } finally {
      commit('SET_IS_LOGGED', false)
      commit('CLEAR_LOGGED_USER')
      commit('RESET')
      dispatch('user/doResetState', {}, { root: true })
      dispatch('cpuMon/doResetState', {}, { root: true })
      dispatch('logMon/doResetState', {}, { root: true })
      dispatch('sessionMon/doResetState', {}, { root: true })
      commit('hsm/RENEW_INSTANCE', null, { root: true })
    }
  },
  async doSetAcl ({ commit, state, rootState, dispatch }) {
    try {
      const hsm = rootState.hsm.instance
      const res = await hsm.getAcl({ body: { usr: state.username } })
      commit('SET_ACL', res.acl)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async doChangePassword ({ dispatch, state, commit, rootState }) {
    try {
      const hsm = rootState.hsm.instance
      await hsm.changePassword({ body: { pwd: state.password } })
    } catch (err) {
      commit('CLEAR_AFTER_ERROR')
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  }
}
